import { create } from "zustand";
import { persist } from "zustand/middleware";

const ChatStore = create(
  persist(
    (set) => ({
      chat: null, // Add chat data to the store
      setchat: (chat) => set({ chat }), // Action to set chat data
      clearchat: () => set({ chat: null}), // Action to clear chat data
    }),
    {
      name: "chat-storage", // Name of the item in storage
      getStorage: () => localStorage, // Use localStorage to persist data
    }
  )
);

export default ChatStore;
